<template>
  <div class="mb-4 pb-4">
    <base-link-with-icon
      v-if="canEdit"
      :disabled="creating"
      size="m"
      class="ml-4 mb-4"
      @click="activateCreate"
    >
      New Folder
    </base-link-with-icon>
    <base-text
      v-for="(folder, index) in folders"
      :key="`collateral_folder_${index}`"
      :class="`${folder.selected ? 'selected' : ''} folderitem`"
      @click.native="$emit('change-folder', folder)"
    >
      <base-hover
        v-slot="{isHover}"
        class="d-flex align-items-center justify-content-between flex-wrap position-relative"
      >
        <div :class="`${isHover ? 'pr-3' : ''}`">
          <span class="foldername text-break">
            {{ folder.name ? folder.name : `Untitled ${folder.pk}` }}
          </span>
          &nbsp;
          <span v-if="folder.files_count !== undefined">
            ({{ folder.files_count }})
          </span>
        </div>
        <transition name="fade">
          <base-icon
            v-if="isHover && folder.pk >= 0 && folder.editable"
            icon="cancel"
            style="right: 0"
            class="ml-auto delete p-1 position-absolute"
            @click="onDeleteClicked(folder)"
          />
        </transition>
      </base-hover>
    </base-text>
    <transition name="fade">
      <base-text
        v-if="creating"
        class="folderitem border border-dark"
        @focusout.native="creating=false"
      >
        <base-texteditable
          ref="input"
          v-model="newFolderName"
          placeholder="Folder Name"
          max-width="130px"
          class="foldername"
          @blur="onCreateFolder"
          @complete="onCreateFolder"
        />
      </base-text>
    </transition>
    <base-confirm-dialog
      v-if="folderToDelete"
      :message="`Are you sure you want to delete &quot;${folderToDelete.name}?&quot;`"
      positive-text="Delete"
      @confirmed="onConfirmDelete"
      @cancelled="onCancelDelete"
    />
  </div>
</template>
<script>
export default {
  props: {
    folders: {
      type: Array,
      default: () => [],
    },
    canEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      creating: false,
      newFolderName: '',

      folderToDelete: null,
    };
  },
  methods: {
    onCreateFolder() {
      this.creating = false;
      this.$emit('create', this.newFolderName);
    },
    activateCreate() {
      this.creating = true;
      this.newFolderName = '';
      this.$nextTick().then(() => {
        this.$refs.input.focus();
      });
    },
    onDeleteClicked(folder) {
      this.folderToDelete = folder;
    },
    onConfirmDelete() {
      const { pk } = this.folderToDelete;
      this.folderToDelete = null;
      this.$emit('delete', pk);
    },
    onCancelDelete() {
      this.folderToDelete = null;
    },
  },
};
</script>
<style scoped
       lang="scss">
.folderitem {
  cursor: pointer;
  font-size: 13px;
  padding: 3px 8px;
  border-radius: 2px;
  margin-left: 18px;
  font-family: $font-family-sans-serif-light;
  transition: background-color .3s ease;

  &:hover {
    background-color: #F2F1EE;
  }

  &.selected {
    background-color: #F2F1EE;

    .foldername {
      font-family: $font-family-sans-serif-semibold;
    }
  }
}

.delete {
  border-radius: 4px;
  transition: background-color .2s ease;
  &:hover {
    background-color: white;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}
</style>
